import { StateBadgeConfig } from './financerDistributionFormat';

export default function StateBadge({ label, bg, color }: StateBadgeConfig) {
    return (
        <span style={{
            padding: '2px 10px', borderRadius: 12, fontSize: 12,
            fontWeight: 600, background: bg, color, whiteSpace: 'nowrap',
        }}>
            {label}
        </span>
    );
}
